<template>
  <AsyncComponent
    :request-status="requestStatus"
    error-message="Raportite laadimine ebaõnnestus"
  >
    <section v-for="(reports, category) in reportsByCategory" :key="category">
      <v-container>
        <h2>{{ category }}</h2>
        <v-row>
          <v-col
            v-for="report in reports"
            :key="report.code"
            class="pa-1"
            cols="12"
            sm="4"
          >
            <Report :report="report" />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </AsyncComponent>
</template>

<script>
import { ApiRequestStatus } from '@/dataAccess/ApiRequestStatus'
import ReportInfo from '@/dataAccess/dto/ReportInfo'
import Report from '@/views/Reports/ReportCard'
import AsyncComponent from '@/components/AsyncComponent'
import { groupByField, sortByKeys } from '@/utils/object'

export default {
  components: { AsyncComponent, Report },
  data() {
    return {
      requestStatus: ApiRequestStatus.ofLoading(),
      reportsByCategory: []
    }
  },
  async created() {
    let reports
    ;[reports, this.requestStatus] = await ReportInfo.getAllFromApi()
    this.reportsByCategory = sortReportsByCategory(reports)
  }
}

function sortReportsByCategory(reports) {
  return sortByKeys(groupByField(reports, 'category'))
}
</script>
